module.exports = __webpack_public_path__ + "img/times-regular.c98d8f88.svg";